<div
  class="context-menu"
  [ngStyle]="getCoords()"
  *ngIf="contextMenuObject?.length >= 1"
>
  <div class="dropdown">
    <ul class="list-unstyled">
      <li *ngFor="let menu of contextMenuObject">
        <button
          (click)="runAction(menu.name, '', menu.customLinkEvent, menu)"
          [disabled]="!menu.isEnabled"
          *ngIf="!menu.showTree"
          class="nav-link"
        >
          <span class="nav-text {{ menu.key }}">
            {{ menu.name }}

            <ng-template #showName>
              {{ menu.name }}
            </ng-template>
          </span>
          <span *ngIf="menu.key === 'goToLink'">
            <img
              src="assets/images/external-link.svg"
              class="wk-external-link-icon"
              alt=""
            />
          </span>
        </button>

        <button
          *ngIf="menu.showTree"
          class="nav-link"
          [disabled]="!menu.isEnabled"
          (click)="showSubMenu = !showSubMenu"
        >
          <span class="nav-text">{{ menu.name }}</span>
          <span class="wk-icon-chevron-right wk-icon"></span>
        </button>
        <div
          *ngIf="
            menu.showTree && showSubMenu && menu.subTemplateObject.length >= 1
          "
          class="collapse"
          [style.bottom]="
            contextMenuObject.length > 1 && menu.name === 'Insert Subtemplate'
              ? '32px'
              : '0px'
          "
        >
          <ul class="submenu-list-unstyled list-unstyled">
            <li *ngFor="let subMenu of menu.subTemplateObject">
              <button
                [disabled]="!subMenu.isEnabled"
                class="nav-link"
                (click)="runAction(menu.name, subMenu.name, subMenu, menu)"
              >
                <span
                  class="nav-text"
                  title="{{ subMenu.title ? subMenu.title : subMenu.name }}"
                  >{{ subMenu.title ? subMenu.title : subMenu.name }}</span
                >
              </button>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</div>
